export const MANAGE_INGREDIENT_FETCHING = 'MANAGE_INGREDIENT_FETCHING';
export const MANAGE_INGREDIENT_FETCH_ERROR = 'MANAGE_INGREDIENT_FETCH_ERROR';
export const MANAGE_INGREDIENT_CLEAR_ERRORS = 'MANAGE_INGREDIENT_CLEAR_ERRORS';
export const MANAGE_INGREDIENT_FETCH_SUCCESS =
  'MANAGE_INGREDIENT_FETCH_SUCCESS';
export const MANAGE_INGREDIENT_SET_SAVE_SUCCESSFUL =
  'MANAGE_INGREDIENT_SET_SAVE_SUCCESSFUL';
export const MANAGE_INGREDIENT_SET_INGREDIENT_SOURCES =
  'MANAGE_INGREDIENT_SET_INGREDIENT_SOURCES';
export const MANAGE_INGREDIENT_SET_INGREDIENT_GROUPS =
  'MANAGE_INGREDIENT_SET_INGREDIENT_GROUPS';
export const MANAGE_INGREDIENT_FETCHING_GROUPS =
  'MANAGE_INGREDIENT_FETCHING_GROUPS';
export const MANAGE_INGREDIENT_FETCHING_SOURCES =
  'MANAGE_INGREDIENT_FETCHING_SOURCES';
export const MANAGE_INGREDIENT_SET_DELETE_SUCCESSFUL =
  'MANAGE_INGREDIENT_SET_DELETE_SUCCESSFUL';
export const MANAGE_INGREDIENT_SET_RECIPES_WITH_INGREDIENT =
  'MANAGE_INGREDIENT_SET_RECIPES_WITH_INGREDIENT';
export const MANAGE_INGREDIENT_SET_CONVERT_TO_RECIPE_SUCCESSFUL =
  'MANAGE_INGREDIENT_SET_CONVERT_TO_RECIPE_SUCCESSFUL';



// WEBPACK FOOTER //
// ./src/pages/manageingredient/state/editingredient/types.js